import React from 'react'
import { Image as Img } from '../components'
import { useStore } from '../lib'

type Props = {
  childrenLeft: any
  childrenRight: any
  isFinished?: boolean
  isWhiteBg?: boolean
  onExit: ([e]: any) => void
}
export const GameFrame: React.FC<Props> = ({ childrenLeft, childrenRight, isFinished, isWhiteBg, onExit }) => {
  const { state } = useStore()

  return (
    <div className="flex flex-row mt-5" style={{ height: `calc(100% - 2.5rem)`, width: 'calc(100% - 19.25rem)' }}>
      <div
        className={`flex flex-row flex-wrap w-9/12 h-full p-5 mb-5 ${
          !isFinished && `card shadow-xl opacity-90 ${isWhiteBg ? 'bg-white' : 'glass'}`
        }`}
      >
        {isFinished && (
          <div className="w-full flex flex-col justify-center items-center p-2">
            <div className="card glass p-2">
              <p className="text-center font-bold ml-16 mr-16">Hotovo!</p>
              <p className="text-left mt-2 mb-3">
                Správně {state.score}
                <br />
                Chybně {state.errors}
              </p>
              <button className="btn btn-primary mt-auto" onClick={() => window.location.reload()}>
                Hrát znovu
              </button>
              <button className="btn btn-primary mt-2" onClick={onExit}>
                Zpět na rozcestí
              </button>
            </div>
          </div>
        )}
        {!isFinished && childrenLeft}
      </div>
      <div className="w-3/12 flex flex-col pl-5 justify-center">{childrenRight}</div>
    </div>
  )
}
